import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { addStateFetch } from '@webapp/account/src/resources/store-utils';

import { arrDeleteById } from '@webapp/common/lib/utils';

import { getHistoryList, getLicense, removeOrder, sendOrder } from './async';
import type { License } from './license';
import { initialState } from './state';

export const ordersSlice = createSlice({
    name: 'orders',
    initialState,
    reducers: {
        licenseSelect(s, { payload: { license, num } }: PayloadAction<{ license: License; num: number }>) {
            s.orders = [
                {
                    id: license.id,
                    name: license.name,
                    sum: license.price,
                    amount: num,
                    payPeriod: license.durationType === 'Y' ? 'Ежегодно*' : '-',
                },
            ];
        },
    },
    extraReducers: (builder) =>
        addStateFetch(
            builder
                .addCase(getLicense.fulfilled, (s, { payload: { licenses } }) => {
                    s.licenses = licenses;
                })
                .addCase(getHistoryList.fulfilled, (s, { payload: { histories } }) => {
                    s.histories = histories;
                })
                .addCase(removeOrder.fulfilled, ({ histories }, { payload: { orderId } }) => {
                    arrDeleteById(histories, [orderId]);
                })
                .addCase(sendOrder.fulfilled, (s, { payload: { id } }) => {
                    s.orders = [];
                    s.invoiceId = id;
                }),
        ),
});
